import script from "./ValidatedPasswordInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatedPasswordInput.vue?vue&type=script&setup=true&lang=js"

import "./ValidatedPasswordInput.vue?vue&type=style&index=0&id=5654de2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5654de2f"]])

export default __exports__